var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './search.group-selector.component.less';
import { isArray, isEmpty, isNumber, isString, trim } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'office';
const componentName = 'search';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxOfficeSearch = {
    bindings: {
        elementId: '@',
        tokenUrl: '@',
        listId: '@',
        listLinkUrl: '@',
        listLinkTarget: '@',
        options: '@',
        template: '@',
        variableSync: '@',
        syncInstance: '@',
        syncInstanceVariable: '@',
        syncInstanceVariableIndex: '@'
    },
    controller($attrs, $scope, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        Stratus.Instances[$scope.elementId] = $scope;
        $scope.selectionGroup = {
            name: '',
            group: []
        };
        $scope.itemsSelectable = [];
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
        }
        Stratus.Internals.CssLoader(localDistStyle).then();
        this.$onInit = () => {
            var _a, _b;
            var _c, _d;
            $scope.listId = $attrs.listId || null;
            $scope.listInitialized = false;
            $scope.listLinkUrl = $attrs.listLinkUrl || '/property/office/list';
            $scope.listLinkTarget = $attrs.listLinkTarget || '_self';
            $scope.syncInstance = $attrs.syncInstance || null;
            $scope.syncInstanceVariable = $attrs.syncInstanceVariable || null;
            $scope.syncInstanceVariableIndex = ($attrs.syncInstanceVariableIndex && isString($attrs.syncInstanceVariableIndex) ?
                parseInt($attrs.syncInstanceVariableIndex, 10) : null) || ($attrs.syncInstanceVariableIndex && isNumber($attrs.syncInstanceVariableIndex) ?
                $attrs.syncInstanceVariableIndex : null) || 0;
            $scope.updateSyncedGroupSelection(true);
            $scope.options = $attrs.options && isJSON($attrs.options) ? JSON.parse($attrs.options) : {};
            (_a = (_c = $scope.options).query) !== null && _a !== void 0 ? _a : (_c.query = {});
            (_b = (_d = $scope.options.query).where) !== null && _b !== void 0 ? _b : (_d.where = {});
            if ($scope.options.tokenUrl) {
                Idx.setTokenURL($scope.options.tokenUrl);
            }
            Idx.registerSearchInstance($scope.elementId, moduleName, $scope, $scope.listId);
            if ($scope.listId) {
                Idx.on($scope.listId, 'init', $scope.refreshSearchWidgetOptions);
                Idx.on($scope.listId, 'searching', $scope.refreshSearchWidgetOptions);
                Idx.on($scope.listId, 'collectionUpdated', $scope.collectionUpdated);
            }
            $scope.$applyAsync(() => {
                $scope.initialized = true;
                Idx.emit('init', $scope);
            });
        };
        $scope.search = () => __awaiter(this, void 0, void 0, function* () {
            let listScope;
            if ($scope.listId) {
                listScope = Idx.getListInstance($scope.listId, 'office');
            }
            if (listScope) {
                yield listScope.search($scope.options.query, true);
            }
        });
        $scope.collectionUpdated = (_listScope, collection) => __awaiter(this, void 0, void 0, function* () {
            if (isEmpty(trim($scope.selectionGroup.name)) &&
                !isEmpty(trim($scope.options.query.where.OfficeName))) {
                $scope.selectionGroup.name = $scope.options.query.where.OfficeName;
            }
            $scope.itemsSelectable = [];
            collection.models.forEach((office) => {
                $scope.itemsSelectable.push({
                    id: office._OfficeNumber,
                    listing: office,
                    selected: $scope.selectionGroup.group.includes(office._OfficeNumber)
                });
            });
        });
        $scope.toggleSelected = (itemId, remove) => {
            const selectedIndex = $scope.selectionGroup.group.indexOf(itemId);
            const nowSelected = remove ? false : (selectedIndex === -1);
            if (nowSelected) {
                $scope.selectionGroup.group.push(itemId);
                $scope.itemsSelectable.forEach((officeSelectable) => {
                    if (officeSelectable.id === itemId) {
                        officeSelectable.selected = true;
                    }
                });
            }
            else {
                if (selectedIndex > -1) {
                    $scope.selectionGroup.group.splice(selectedIndex, 1);
                }
                $scope.itemsSelectable.forEach((officeSelectable) => {
                    if (officeSelectable.id === itemId) {
                        officeSelectable.selected = false;
                    }
                });
            }
            $scope.updateSyncedGroupSelection();
        };
        $scope.updateSyncedGroupSelection = (initialize) => {
            if ($scope.syncInstance &&
                Stratus.Instances[$scope.syncInstance] &&
                $scope.syncInstanceVariable) {
                const parentVariable = Idx.getScopeValuePath(Stratus.Instances[$scope.syncInstance], $scope.syncInstanceVariable);
                let updatedValue;
                if (isArray(parentVariable)) {
                    if (initialize &&
                        !isEmpty(parentVariable[$scope.syncInstanceVariableIndex]) &&
                        !isString(parentVariable[$scope.syncInstanceVariableIndex]) &&
                        Object.prototype.hasOwnProperty.call(parentVariable[$scope.syncInstanceVariableIndex], 'name')) {
                        $scope.selectionGroup = parentVariable[$scope.syncInstanceVariableIndex];
                    }
                    updatedValue = parentVariable;
                    updatedValue[$scope.syncInstanceVariableIndex] = $scope.selectionGroup;
                }
                else {
                    updatedValue = $scope.selectionGroup;
                }
                Idx.updateScopeValuePath(Stratus.Instances[$scope.syncInstance], $scope.syncInstanceVariable, updatedValue).then();
            }
        };
        $scope.refreshSearchWidgetOptions = (listScope) => __awaiter(this, void 0, void 0, function* () {
            if (!listScope &&
                $scope.listId) {
                listScope = Idx.getListInstance($scope.listId);
            }
            if (listScope) {
                $scope.listInitialized = true;
            }
        });
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=search.component.js.map
